import { useSelector } from 'react-redux'

import { getIsApplePayEnabled } from 'routes/Checkout/checkoutSelectors'

/**
 * Returns true if Apple Pay is supported by browser.
 */
export const useIsApplePayEnabled = (): boolean => useSelector(getIsApplePayEnabled) || false
